import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 6a6 6 0 1 0 0 12","key":"svg-0"}],["path",{"d":"M21 6a6 6 0 1 0 0 12","key":"svg-1"}],["path",{"d":"M15 12h6","key":"svg-2"}]]

/**
 * IconCe
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2UiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTkgNmE2IDYgMCAxIDAgMCAxMiIgLz4KICA8cGF0aCBkPSJNMjEgNmE2IDYgMCAxIDAgMCAxMiIgLz4KICA8cGF0aCBkPSJNMTUgMTJoNiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/ce
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCe = createReactComponent('outline', 'ce', 'Ce', __iconNode);

export default IconCe;